import createModule from "../createModule"
import view from "./view"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getSelectedModelId } from "./selectors"
import { getDisplayAddView } from "./selectors/factors"
import { getStartDate, getEndDate, getSelectedDate, getModelCurrentDate, getModelFactorsStartDate, getDatesAdjusted } from "./selectors/dates"
import { getPeriodOrStartAndEndDates } from "selectors/queryString/dates"
import withOutletContext from "hocs/withOutletContext"
import { MODEL_METADATA_QUERY } from "resources/models"
import { FAVORITE_FACTORS_TYPE } from "modules/portfolio-root/model"

export default withUrlParams(withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
    modelId: getSelectedModelId(state, props),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    fetchStartDate: getStartDate(state),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "factorTrendsDates",
    url: ({ modelId }) => ({
      id: modelId,
      query: "query ($modelId: String!) { model (id: $modelId) { availability { currentDate, factorsStartDate, securitiesStartDate } } }",
      variables: { modelId },
    }),
  }, MODEL_METADATA_QUERY, {
    resource: "userFavoriteFactors",
    passthrough: true,
    url: ({ accountId, modelId }) => ({
      id: `userFavoriteFactors-${accountId}${modelId}`,
      url: "/api/users/me/preferences",
      payload: {
        items: [{
          type: FAVORITE_FACTORS_TYPE,
          key: `${modelId}`,
          accountId,
        }],
      },
    }),
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.factorTrends,
    earliestDate: getModelFactorsStartDate(state, props),
    latestDate: getModelCurrentDate(state, props),
    period: getPeriodOrStartAndEndDates(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    displayAddView: getDisplayAddView(state, props),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
})))
